import $ from 'jquery';
import svg4everybody from 'svg4everybody/dist/svg4everybody';

$(document).ready(() => {
  svg4everybody();
});



// WEBPACK FOOTER //
// ./js/components/init-svg4everybody.js